module.exports = __webpack_public_path__ + "img/right-page.c865397b.png";